import client from "api/client";

// formSubmissionsApi — website + form scoped
// /websites/{websiteId}/forms/{formId}/submissions. A submission always
// belongs to one form, so both ids come from the route.
//
// The event-tracking endpoints (/events, /event-executions) have no
// website-scoped twin — they stay on the flat routes by backend design.

// Allowed form-submission status values (backend enum).
export const FORM_SUBMISSION_STATUSES = ["pending", "spam", "processed"];

export const listFormSubmissions = async (websiteId, formId, params = {}) => {
  const { data } = await client.get(`/websites/${websiteId}/forms/${formId}/submissions`, {
    params,
  });
  return { items: data.items ?? [], total: data.total ?? 0, hasMore: !!data.has_more };
};

export const getFormSubmission = async (websiteId, formId, id) => {
  const { data } = await client.get(`/websites/${websiteId}/forms/${formId}/submissions/${id}`);
  return data;
};

export const createFormSubmission = async (websiteId, formId, payload) => {
  const { data } = await client.post(`/websites/${websiteId}/forms/${formId}/submissions`, payload);
  return data;
};

export const updateFormSubmission = async (websiteId, formId, id, payload) => {
  const { data } = await client.put(
    `/websites/${websiteId}/forms/${formId}/submissions/${id}`,
    payload
  );
  return data;
};

export const deleteFormSubmission = async (websiteId, formId, id) => {
  await client.delete(`/websites/${websiteId}/forms/${formId}/submissions/${id}`);
};

// GET /events/aggregates/:formSubmissionId — flat-only. Expected { events: [...] }.
export const getEventsByFormSubmissionId = async (formSubmissionId) => {
  const { data } = await client.get(`/events/aggregates/${formSubmissionId}`);
  return data;
};

// GET /events/:id/executions — flat-only.
export const getEventExecutions = async (id) => {
  const { data } = await client.get(`/events/${id}/executions`);
  return data;
};
